import * as React from 'react';
import { FormattedMessage  } from 'react-intl';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faBars, faChevronDown, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import deFlag from '../flags/germany-flag-xs.png'
//import ukFlag from '../flags/united-kingdom-flag-xs.png'
//import frFlag from '../flags/france-flag-xs.png'
//import arFlag from '../flags/united-arab-emirates-flag-xs.png'
import ReadingProgress from 'react-reading-progress'

import './header.scss';
library.add(faSearch, faBars, faChevronDown, faArrowRight);

class Header extends React.Component {
  render() {
    let baseUrl = this.props.state.baseUrl ? this.props.state.baseUrl : ".";
    let isArticle = this.props.state.loadedArticle.articleType === "text" ? true : false;
    let tmpIssues = [];


    if(this.props.state.issues){
      tmpIssues = this.props.state.issues.map((item, key) =>
          <div className='col-12 col-sm-4 col-md-3' key={"menuKey_"+item.issueId+key}>
            {item.issueExtLink &&
            <a className='issue-menu-item' target={'_self'} href={item.issueExtLink}>
              <div className="forced-16-9" style={{backgroundImage: 'url('+baseUrl+item.issueThumbnail+')'}}>
                <img className='issue-menu-thumb img-fluid' src={baseUrl+"/images/16-9.png"} alt={item.issueTitle} />
              </div> 
                <span className='issue-menu-title' >{item.issueTitle}</span><span className="issue-menu-arrow"><FontAwesomeIcon icon="arrow-right" /></span>
            </a>
            } 
            {!item.issueExtLink &&
              <a className='issue-menu-item' onClick={() => {this.props.changeRoute(item.issueId, "")}} href={'./index.html?issueid='+item.issueId+"&lang="+this.props.state.locale}>
              <div className="forced-16-9" style={{backgroundImage: 'url('+baseUrl+item.issueThumbnail+')'}}>
                <img className='issue-menu-thumb img-fluid' src={baseUrl+"/images/16-9.png"} alt={item.issueTitle} />
              </div> 
                <span className='issue-menu-title' >{item.issueTitle}</span><span className="issue-menu-arrow"><FontAwesomeIcon icon="arrow-right" /></span>
              </a>
            }
          </div>
      );
    }
    
    return (
      <header id="app-header" className={this.props.state.issueHeroFixed ? "issueHeroFixed" : ""}>
        <div id='navigation_container'>
          <div className="container">
            <nav className="app-navigation d-flex flex-row align-items-center">
              <div className="logo-spacer">
                  <img className="logo" src={baseUrl+"/images/ocloudlogo.svg"} alt="Oracle Logo"/>
              </div>
              <div className="header-title d-none d-md-block">
              <a onClick={() => {this.props.changeRoute("", "")}} href={"./index.html?lang="+this.props.state.locale}>
                <FormattedMessage id="Header.title" defaultMessage="Your Tomorrow, Today" />
              </a>
              </div>
              <div className="ml-auto">
                <ul className="nav"> 
                  <li className="nav-item">
                    <button className={this.props.state.issueMenuOpen ? "btn btn-link" : "btn btn-link collapsed"} id="issueSelect" onClick={this.props.issueMenuHandler} aria-controls='issues_menu' aria-expanded={this.props.state.issueMenuOpen}>
                    <span><FormattedMessage id="Header.issues" defaultMessage="Issues" /></span><FontAwesomeIcon icon="chevron-down" />
                    </button>
                  </li>
                  <li className={this.props.state.langMenuOpen ? "nav-item dropdown show" : "nav-item dropdown"}>
                    <button className="btn btn-link" id="langSelect" aria-haspopup="true" onClick={this.props.langMenuHandler} aria-expanded={this.props.state.langMenuOpen}>
                    <span className="d-none d-md-inline-block" ><FormattedMessage id="Header.language" defaultMessage="Language" /></span>
                    <span className="d-md-none" ><FormattedMessage id="Header.languageMobile" defaultMessage="Language" /></span>
                    <FontAwesomeIcon icon="chevron-down" />
                    </button>
                    <div className={this.props.state.langMenuOpen ? "dropdown-menu show" : "dropdown-menu"} aria-labelledby="langSelect">
                      <a className="dropdown-item" href={'./index.html?issueid='+this.props.state.activeIssueId+'&articleid='+this.props.state.activeArticleId+"&lang=en"}><FormattedMessage id="Header.english" defaultMessage="English" /></a>
                      <a className="dropdown-item" href={'./index.html?issueid='+this.props.state.activeIssueId+'&articleid='+this.props.state.activeArticleId+"&lang=fr"}><FormattedMessage id="Header.french" defaultMessage="French" /></a>
                      <a className="dropdown-item" href={'./index.html?issueid='+this.props.state.activeIssueId+'&articleid='+this.props.state.activeArticleId+"&lang=de"}><FormattedMessage id="Header.german" defaultMessage="German" /></a>
                      <a className="dropdown-item" href={'./index.html?issueid='+this.props.state.activeIssueId+'&articleid='+this.props.state.activeArticleId+"&lang=ar"}><FormattedMessage id="Header.arabic" defaultMessage="Arabic" /></a>
                      <a className="dropdown-item" href={'./index.html?issueid='+this.props.state.activeIssueId+'&articleid='+this.props.state.activeArticleId+"&lang=ja"}><FormattedMessage id="Header.japanese" defaultMessage="Japanese" /></a>
                    </div>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        {isArticle && <ReadingProgress className='read-progress'/> }
        </div>
        <div id='issues_menu_container' style={{transform: 'translateY(-100%)'}} className={this.props.state.issueMenuOpen ? "open" : "closed"}>
          <div className='container'>
            <div id="issues_menu">
              <div className='row sm-no-pad'>
                  {tmpIssues}
              </div>
            </div>
          </div>
        </div>
      </header >
    );
  }
}

export default Header;

/*
removed temp search
  <li className="nav-item active">
    <button className="btn btn-link">
      <FontAwesomeIcon icon="search" />
      <span className="sr-only"><FormattedMessage id="Header.search" defaultMessage="Search" /></span>
    </button>
  </li>
*/

/* removed flags
  <a className="dropdown-item" href="?lang=en"><img src={ukFlag} className="flag" alt={<FormattedMessage id="Header.english" defaultMessage="English" />} /><FormattedMessage id="Header.english" defaultMessage="English" /></a>
  <a className="dropdown-item" href="?lang=fr"><img src={frFlag} className="flag" alt={<FormattedMessage id="Header.french" defaultMessage="French" />} /><FormattedMessage id="Header.french" defaultMessage="French" /></a>
  <a className="dropdown-item" href="?lang=de"><img src={deFlag} className="flag" alt={<FormattedMessage id="Header.german" defaultMessage="German" />} /><FormattedMessage id="Header.german" defaultMessage="German" /></a>
  <a className="dropdown-item" href="?lang=ar"><img src={arFlag} className="flag" alt={<FormattedMessage id="Header.arabic" defaultMessage="Arabic" />} /><FormattedMessage id="Header.arabic" defaultMessage="Arabic" /></a>
*/

/* removed langs 
*/